import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

if (process.env.REACT_APP_MOCK === 'true') {
  require('./mock');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
